import React from 'react';

// Styles & Assets
import styles from './DrugNameCell.module.css';
import { RiArrowDownSFill, RiArrowUpSFill, /*RiPencilFill*/ } from 'react-icons/ri';
import { MdInfo } from 'react-icons/md';

//Services
import { sortArray } from '../../../services/sort';

// Components
import Tooltip from '../../UI/Tooltip/Tooltip';

// Interfaces
import { DrugAdministrationList } from '../../../interfaces/Drug';

const DrugNameCell: React.FC<{
    drug: DrugAdministrationList
    dropdownRow?: {
        showElements?: boolean,
        handleClickDropdown: () => void,
    }
    nonDropdownRow?: {
        hour: string,
    },
    optionalTable?: boolean,
}> = ({ drug, dropdownRow, nonDropdownRow, optionalTable }) => {

    // const handleEdit = () => setShowModalEdit(true);

    const hoursDose = sortArray(Object.keys(drug.hours));

    return (
        <>
            {dropdownRow !== undefined ?
                <td className={`pharmaCell ${styles.drugName}`}>
                    <div className={styles.containerName}>
                        {/* <RiPencilFill onClick={handleEdit} className={styles.editButton} /> */}
                        <p className={styles.ellipsis} title={drug.drugName}>
                            {(drug.drugName)}
                        </p>
                    </div>
                    <div className={styles.containerName}>
                        {drug.observation && (
                            <Tooltip text={drug.observation}>
                                <MdInfo className={styles.icon} />
                            </Tooltip>
                        )}
                        <div>
                            {optionalTable &&
                                <div className={styles.SPInfo}>
                                    <p>SP</p>
                                </div>
                            }
                        </div>
                        <button onClick={dropdownRow.handleClickDropdown} className={styles.dropdownArrowButton}>
                            {dropdownRow.showElements ?
                                <RiArrowUpSFill data-testid='arrowupDrugName' />
                                :
                                <RiArrowDownSFill data-testid='arrowdownDrugName' />
                            }
                        </button>
                    </div>
                </td>
                : nonDropdownRow !== undefined && (hoursDose.length > 1 ?
                    <td className={`${styles.dropdownRowCell} ${hoursDose[hoursDose.length - 1] === nonDropdownRow.hour ? styles.lastDropdownElement : ''}`}>
                        <div className={styles.branch}>
                            <div className={styles.verticalLine}></div>
                            <hr className={styles.horizontalLine}></hr>
                        </div>
                        <div className={styles.leafRow}>
                            <div className={styles.containerName}>
                                <p className={styles.ellipsis} title={drug.drugName}>
                                    {drug.drugName}
                                </p>
                            </div>
                            <div className={styles.hour}>
                                {nonDropdownRow.hour}
                            </div>
                        </div>
                    </td>
                    :
                    <td className={`pharmaCell ${styles.drugName}`}>
                        <div className={styles.containerName}>
                            {/* <RiPencilFill onClick={handleEdit} className={styles.editButton} /> */}
                            <p className={styles.ellipsis} title={drug.drugName}>
                                {drug.drugName}
                            </p>
                        </div>
                        <div className={styles.containerName}>
                            {drug.observation && (
                                <Tooltip text={drug.observation}>
                                    <MdInfo className={styles.icon} />
                                </Tooltip>
                            )}
                            <div>
                                {optionalTable &&
                                    <div className={styles.SPInfo}>
                                        <p>SP</p>
                                    </div>
                                }
                            </div>
                            <p className={styles.hour}>{nonDropdownRow.hour}</p>
                        </div>
                    </td>
                )
            }
        </>
    );
};

export default DrugNameCell;